/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.dynatrace = (function() {

    /**
     * Namespace dynatrace.
     * @exports dynatrace
     * @namespace
     */
    var dynatrace = {};

    dynatrace.odin = (function() {

        /**
         * Namespace odin.
         * @memberof dynatrace
         * @namespace
         */
        var odin = {};

        odin.proto = (function() {

            /**
             * Namespace proto.
             * @memberof dynatrace.odin
             * @namespace
             */
            var proto = {};

            proto.collector = (function() {

                /**
                 * Namespace collector.
                 * @memberof dynatrace.odin.proto
                 * @namespace
                 */
                var collector = {};

                collector.trace = (function() {

                    /**
                     * Namespace trace.
                     * @memberof dynatrace.odin.proto.collector
                     * @namespace
                     */
                    var trace = {};

                    trace.v1 = (function() {

                        /**
                         * Namespace v1.
                         * @memberof dynatrace.odin.proto.collector.trace
                         * @namespace
                         */
                        var v1 = {};

                        v1.SpanExport = (function() {

                            /**
                             * Properties of a SpanExport.
                             * @memberof dynatrace.odin.proto.collector.trace.v1
                             * @interface ISpanExport
                             * @property {string|null} [tenantUUID] SpanExport tenantUUID
                             * @property {number|Long|null} [agentId] SpanExport agentId
                             * @property {Uint8Array|null} [exportMetaInfo] SpanExport exportMetaInfo
                             * @property {Uint8Array|null} [resource] SpanExport resource
                             * @property {Array.<dynatrace.odin.proto.collector.trace.v1.IActiveGateSpanEnvelope>|null} [spans] SpanExport spans
                             */

                            /**
                             * Constructs a new SpanExport.
                             * @memberof dynatrace.odin.proto.collector.trace.v1
                             * @classdesc Represents a SpanExport.
                             * @implements ISpanExport
                             * @constructor
                             * @param {dynatrace.odin.proto.collector.trace.v1.ISpanExport=} [properties] Properties to set
                             */
                            function SpanExport(properties) {
                                this.spans = [];
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }

                            /**
                             * SpanExport tenantUUID.
                             * @member {string} tenantUUID
                             * @memberof dynatrace.odin.proto.collector.trace.v1.SpanExport
                             * @instance
                             */
                            SpanExport.prototype.tenantUUID = "";

                            /**
                             * SpanExport agentId.
                             * @member {number|Long} agentId
                             * @memberof dynatrace.odin.proto.collector.trace.v1.SpanExport
                             * @instance
                             */
                            SpanExport.prototype.agentId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                            /**
                             * SpanExport exportMetaInfo.
                             * @member {Uint8Array} exportMetaInfo
                             * @memberof dynatrace.odin.proto.collector.trace.v1.SpanExport
                             * @instance
                             */
                            SpanExport.prototype.exportMetaInfo = $util.newBuffer([]);

                            /**
                             * SpanExport resource.
                             * @member {Uint8Array} resource
                             * @memberof dynatrace.odin.proto.collector.trace.v1.SpanExport
                             * @instance
                             */
                            SpanExport.prototype.resource = $util.newBuffer([]);

                            /**
                             * SpanExport spans.
                             * @member {Array.<dynatrace.odin.proto.collector.trace.v1.IActiveGateSpanEnvelope>} spans
                             * @memberof dynatrace.odin.proto.collector.trace.v1.SpanExport
                             * @instance
                             */
                            SpanExport.prototype.spans = $util.emptyArray;

                            /**
                             * Encodes the specified SpanExport message. Does not implicitly {@link dynatrace.odin.proto.collector.trace.v1.SpanExport.verify|verify} messages.
                             * @function encode
                             * @memberof dynatrace.odin.proto.collector.trace.v1.SpanExport
                             * @static
                             * @param {dynatrace.odin.proto.collector.trace.v1.ISpanExport} message SpanExport message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            SpanExport.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.tenantUUID != null && Object.hasOwnProperty.call(message, "tenantUUID"))
                                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.tenantUUID);
                                if (message.agentId != null && Object.hasOwnProperty.call(message, "agentId"))
                                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.agentId);
                                if (message.exportMetaInfo != null && Object.hasOwnProperty.call(message, "exportMetaInfo"))
                                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.exportMetaInfo);
                                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                                    writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.resource);
                                if (message.spans != null && message.spans.length)
                                    for (var i = 0; i < message.spans.length; ++i)
                                        $root.dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope.encode(message.spans[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                                return writer;
                            };

                            /**
                             * Decodes a SpanExport message from the specified reader or buffer.
                             * @function decode
                             * @memberof dynatrace.odin.proto.collector.trace.v1.SpanExport
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {dynatrace.odin.proto.collector.trace.v1.SpanExport} SpanExport
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            SpanExport.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.collector.trace.v1.SpanExport();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1: {
                                            message.tenantUUID = reader.string();
                                            break;
                                        }
                                    case 2: {
                                            message.agentId = reader.int64();
                                            break;
                                        }
                                    case 3: {
                                            message.exportMetaInfo = reader.bytes();
                                            break;
                                        }
                                    case 4: {
                                            message.resource = reader.bytes();
                                            break;
                                        }
                                    case 5: {
                                            if (!(message.spans && message.spans.length))
                                                message.spans = [];
                                            message.spans.push($root.dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope.decode(reader, reader.uint32()));
                                            break;
                                        }
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };

                            /**
                             * Gets the default type url for SpanExport
                             * @function getTypeUrl
                             * @memberof dynatrace.odin.proto.collector.trace.v1.SpanExport
                             * @static
                             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                             * @returns {string} The default type url
                             */
                            SpanExport.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                                if (typeUrlPrefix === undefined) {
                                    typeUrlPrefix = "type.googleapis.com";
                                }
                                return typeUrlPrefix + "/dynatrace.odin.proto.collector.trace.v1.SpanExport";
                            };

                            return SpanExport;
                        })();

                        v1.ActiveGateSpanEnvelope = (function() {

                            /**
                             * Properties of an ActiveGateSpanEnvelope.
                             * @memberof dynatrace.odin.proto.collector.trace.v1
                             * @interface IActiveGateSpanEnvelope
                             * @property {Uint8Array|null} [traceId] ActiveGateSpanEnvelope traceId
                             * @property {number|Long|null} [serverId] ActiveGateSpanEnvelope serverId
                             * @property {Uint8Array|null} [clusterSpanEnvelope] ActiveGateSpanEnvelope clusterSpanEnvelope
                             */

                            /**
                             * Constructs a new ActiveGateSpanEnvelope.
                             * @memberof dynatrace.odin.proto.collector.trace.v1
                             * @classdesc Represents an ActiveGateSpanEnvelope.
                             * @implements IActiveGateSpanEnvelope
                             * @constructor
                             * @param {dynatrace.odin.proto.collector.trace.v1.IActiveGateSpanEnvelope=} [properties] Properties to set
                             */
                            function ActiveGateSpanEnvelope(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }

                            /**
                             * ActiveGateSpanEnvelope traceId.
                             * @member {Uint8Array|null|undefined} traceId
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope
                             * @instance
                             */
                            ActiveGateSpanEnvelope.prototype.traceId = null;

                            /**
                             * ActiveGateSpanEnvelope serverId.
                             * @member {number|Long|null|undefined} serverId
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope
                             * @instance
                             */
                            ActiveGateSpanEnvelope.prototype.serverId = null;

                            /**
                             * ActiveGateSpanEnvelope clusterSpanEnvelope.
                             * @member {Uint8Array} clusterSpanEnvelope
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope
                             * @instance
                             */
                            ActiveGateSpanEnvelope.prototype.clusterSpanEnvelope = $util.newBuffer([]);

                            // OneOf field names bound to virtual getters and setters
                            var $oneOfFields;

                            /**
                             * ActiveGateSpanEnvelope destinationKey.
                             * @member {"traceId"|"serverId"|undefined} destinationKey
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope
                             * @instance
                             */
                            Object.defineProperty(ActiveGateSpanEnvelope.prototype, "destinationKey", {
                                get: $util.oneOfGetter($oneOfFields = ["traceId", "serverId"]),
                                set: $util.oneOfSetter($oneOfFields)
                            });

                            /**
                             * Encodes the specified ActiveGateSpanEnvelope message. Does not implicitly {@link dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope.verify|verify} messages.
                             * @function encode
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope
                             * @static
                             * @param {dynatrace.odin.proto.collector.trace.v1.IActiveGateSpanEnvelope} message ActiveGateSpanEnvelope message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            ActiveGateSpanEnvelope.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.traceId != null && Object.hasOwnProperty.call(message, "traceId"))
                                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.traceId);
                                if (message.serverId != null && Object.hasOwnProperty.call(message, "serverId"))
                                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.serverId);
                                if (message.clusterSpanEnvelope != null && Object.hasOwnProperty.call(message, "clusterSpanEnvelope"))
                                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.clusterSpanEnvelope);
                                return writer;
                            };

                            /**
                             * Decodes an ActiveGateSpanEnvelope message from the specified reader or buffer.
                             * @function decode
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope} ActiveGateSpanEnvelope
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            ActiveGateSpanEnvelope.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1: {
                                            message.traceId = reader.bytes();
                                            break;
                                        }
                                    case 2: {
                                            message.serverId = reader.int64();
                                            break;
                                        }
                                    case 3: {
                                            message.clusterSpanEnvelope = reader.bytes();
                                            break;
                                        }
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };

                            /**
                             * Gets the default type url for ActiveGateSpanEnvelope
                             * @function getTypeUrl
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope
                             * @static
                             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                             * @returns {string} The default type url
                             */
                            ActiveGateSpanEnvelope.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                                if (typeUrlPrefix === undefined) {
                                    typeUrlPrefix = "type.googleapis.com";
                                }
                                return typeUrlPrefix + "/dynatrace.odin.proto.collector.trace.v1.ActiveGateSpanEnvelope";
                            };

                            return ActiveGateSpanEnvelope;
                        })();

                        v1.ClusterSpanEnvelope = (function() {

                            /**
                             * Properties of a ClusterSpanEnvelope.
                             * @memberof dynatrace.odin.proto.collector.trace.v1
                             * @interface IClusterSpanEnvelope
                             * @property {Uint8Array|null} [traceId] ClusterSpanEnvelope traceId
                             * @property {number|null} [pathInfo] ClusterSpanEnvelope pathInfo
                             * @property {Array.<dynatrace.odin.proto.trace.v1.ICustomTag>|null} [customTags] ClusterSpanEnvelope customTags
                             * @property {Uint8Array|null} [spanContainer] ClusterSpanEnvelope spanContainer
                             */

                            /**
                             * Constructs a new ClusterSpanEnvelope.
                             * @memberof dynatrace.odin.proto.collector.trace.v1
                             * @classdesc Represents a ClusterSpanEnvelope.
                             * @implements IClusterSpanEnvelope
                             * @constructor
                             * @param {dynatrace.odin.proto.collector.trace.v1.IClusterSpanEnvelope=} [properties] Properties to set
                             */
                            function ClusterSpanEnvelope(properties) {
                                this.customTags = [];
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }

                            /**
                             * ClusterSpanEnvelope traceId.
                             * @member {Uint8Array} traceId
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterSpanEnvelope
                             * @instance
                             */
                            ClusterSpanEnvelope.prototype.traceId = $util.newBuffer([]);

                            /**
                             * ClusterSpanEnvelope pathInfo.
                             * @member {number} pathInfo
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterSpanEnvelope
                             * @instance
                             */
                            ClusterSpanEnvelope.prototype.pathInfo = 0;

                            /**
                             * ClusterSpanEnvelope customTags.
                             * @member {Array.<dynatrace.odin.proto.trace.v1.ICustomTag>} customTags
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterSpanEnvelope
                             * @instance
                             */
                            ClusterSpanEnvelope.prototype.customTags = $util.emptyArray;

                            /**
                             * ClusterSpanEnvelope spanContainer.
                             * @member {Uint8Array} spanContainer
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterSpanEnvelope
                             * @instance
                             */
                            ClusterSpanEnvelope.prototype.spanContainer = $util.newBuffer([]);

                            /**
                             * Encodes the specified ClusterSpanEnvelope message. Does not implicitly {@link dynatrace.odin.proto.collector.trace.v1.ClusterSpanEnvelope.verify|verify} messages.
                             * @function encode
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterSpanEnvelope
                             * @static
                             * @param {dynatrace.odin.proto.collector.trace.v1.IClusterSpanEnvelope} message ClusterSpanEnvelope message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            ClusterSpanEnvelope.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.traceId != null && Object.hasOwnProperty.call(message, "traceId"))
                                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.traceId);
                                if (message.pathInfo != null && Object.hasOwnProperty.call(message, "pathInfo"))
                                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pathInfo);
                                if (message.customTags != null && message.customTags.length)
                                    for (var i = 0; i < message.customTags.length; ++i)
                                        $root.dynatrace.odin.proto.trace.v1.CustomTag.encode(message.customTags[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                                if (message.spanContainer != null && Object.hasOwnProperty.call(message, "spanContainer"))
                                    writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.spanContainer);
                                return writer;
                            };

                            /**
                             * Decodes a ClusterSpanEnvelope message from the specified reader or buffer.
                             * @function decode
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterSpanEnvelope
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {dynatrace.odin.proto.collector.trace.v1.ClusterSpanEnvelope} ClusterSpanEnvelope
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            ClusterSpanEnvelope.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.collector.trace.v1.ClusterSpanEnvelope();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1: {
                                            message.traceId = reader.bytes();
                                            break;
                                        }
                                    case 2: {
                                            message.pathInfo = reader.int32();
                                            break;
                                        }
                                    case 3: {
                                            if (!(message.customTags && message.customTags.length))
                                                message.customTags = [];
                                            message.customTags.push($root.dynatrace.odin.proto.trace.v1.CustomTag.decode(reader, reader.uint32()));
                                            break;
                                        }
                                    case 4: {
                                            message.spanContainer = reader.bytes();
                                            break;
                                        }
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };

                            /**
                             * Gets the default type url for ClusterSpanEnvelope
                             * @function getTypeUrl
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterSpanEnvelope
                             * @static
                             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                             * @returns {string} The default type url
                             */
                            ClusterSpanEnvelope.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                                if (typeUrlPrefix === undefined) {
                                    typeUrlPrefix = "type.googleapis.com";
                                }
                                return typeUrlPrefix + "/dynatrace.odin.proto.collector.trace.v1.ClusterSpanEnvelope";
                            };

                            return ClusterSpanEnvelope;
                        })();

                        v1.SpanContainer = (function() {

                            /**
                             * Properties of a SpanContainer.
                             * @memberof dynatrace.odin.proto.collector.trace.v1
                             * @interface ISpanContainer
                             * @property {Array.<dynatrace.odin.proto.trace.v1.ISpan>|null} [spans] SpanContainer spans
                             */

                            /**
                             * Constructs a new SpanContainer.
                             * @memberof dynatrace.odin.proto.collector.trace.v1
                             * @classdesc Represents a SpanContainer.
                             * @implements ISpanContainer
                             * @constructor
                             * @param {dynatrace.odin.proto.collector.trace.v1.ISpanContainer=} [properties] Properties to set
                             */
                            function SpanContainer(properties) {
                                this.spans = [];
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }

                            /**
                             * SpanContainer spans.
                             * @member {Array.<dynatrace.odin.proto.trace.v1.ISpan>} spans
                             * @memberof dynatrace.odin.proto.collector.trace.v1.SpanContainer
                             * @instance
                             */
                            SpanContainer.prototype.spans = $util.emptyArray;

                            /**
                             * Encodes the specified SpanContainer message. Does not implicitly {@link dynatrace.odin.proto.collector.trace.v1.SpanContainer.verify|verify} messages.
                             * @function encode
                             * @memberof dynatrace.odin.proto.collector.trace.v1.SpanContainer
                             * @static
                             * @param {dynatrace.odin.proto.collector.trace.v1.ISpanContainer} message SpanContainer message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            SpanContainer.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.spans != null && message.spans.length)
                                    for (var i = 0; i < message.spans.length; ++i)
                                        $root.dynatrace.odin.proto.trace.v1.Span.encode(message.spans[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                                return writer;
                            };

                            /**
                             * Decodes a SpanContainer message from the specified reader or buffer.
                             * @function decode
                             * @memberof dynatrace.odin.proto.collector.trace.v1.SpanContainer
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {dynatrace.odin.proto.collector.trace.v1.SpanContainer} SpanContainer
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            SpanContainer.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.collector.trace.v1.SpanContainer();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1: {
                                            if (!(message.spans && message.spans.length))
                                                message.spans = [];
                                            message.spans.push($root.dynatrace.odin.proto.trace.v1.Span.decode(reader, reader.uint32()));
                                            break;
                                        }
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };

                            /**
                             * Gets the default type url for SpanContainer
                             * @function getTypeUrl
                             * @memberof dynatrace.odin.proto.collector.trace.v1.SpanContainer
                             * @static
                             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                             * @returns {string} The default type url
                             */
                            SpanContainer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                                if (typeUrlPrefix === undefined) {
                                    typeUrlPrefix = "type.googleapis.com";
                                }
                                return typeUrlPrefix + "/dynatrace.odin.proto.collector.trace.v1.SpanContainer";
                            };

                            return SpanContainer;
                        })();

                        v1.ClusterExportEnvelope = (function() {

                            /**
                             * Properties of a ClusterExportEnvelope.
                             * @memberof dynatrace.odin.proto.collector.trace.v1
                             * @interface IClusterExportEnvelope
                             * @property {number|Long|null} [agentId] ClusterExportEnvelope agentId
                             * @property {Uint8Array|null} [exportMetaInfo] ClusterExportEnvelope exportMetaInfo
                             * @property {Uint8Array|null} [resource] ClusterExportEnvelope resource
                             * @property {Array.<Uint8Array>|null} [spanEnvelope] ClusterExportEnvelope spanEnvelope
                             */

                            /**
                             * Constructs a new ClusterExportEnvelope.
                             * @memberof dynatrace.odin.proto.collector.trace.v1
                             * @classdesc Represents a ClusterExportEnvelope.
                             * @implements IClusterExportEnvelope
                             * @constructor
                             * @param {dynatrace.odin.proto.collector.trace.v1.IClusterExportEnvelope=} [properties] Properties to set
                             */
                            function ClusterExportEnvelope(properties) {
                                this.spanEnvelope = [];
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }

                            /**
                             * ClusterExportEnvelope agentId.
                             * @member {number|Long} agentId
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterExportEnvelope
                             * @instance
                             */
                            ClusterExportEnvelope.prototype.agentId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                            /**
                             * ClusterExportEnvelope exportMetaInfo.
                             * @member {Uint8Array} exportMetaInfo
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterExportEnvelope
                             * @instance
                             */
                            ClusterExportEnvelope.prototype.exportMetaInfo = $util.newBuffer([]);

                            /**
                             * ClusterExportEnvelope resource.
                             * @member {Uint8Array} resource
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterExportEnvelope
                             * @instance
                             */
                            ClusterExportEnvelope.prototype.resource = $util.newBuffer([]);

                            /**
                             * ClusterExportEnvelope spanEnvelope.
                             * @member {Array.<Uint8Array>} spanEnvelope
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterExportEnvelope
                             * @instance
                             */
                            ClusterExportEnvelope.prototype.spanEnvelope = $util.emptyArray;

                            /**
                             * Encodes the specified ClusterExportEnvelope message. Does not implicitly {@link dynatrace.odin.proto.collector.trace.v1.ClusterExportEnvelope.verify|verify} messages.
                             * @function encode
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterExportEnvelope
                             * @static
                             * @param {dynatrace.odin.proto.collector.trace.v1.IClusterExportEnvelope} message ClusterExportEnvelope message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            ClusterExportEnvelope.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.agentId != null && Object.hasOwnProperty.call(message, "agentId"))
                                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.agentId);
                                if (message.exportMetaInfo != null && Object.hasOwnProperty.call(message, "exportMetaInfo"))
                                    writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.exportMetaInfo);
                                if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.resource);
                                if (message.spanEnvelope != null && message.spanEnvelope.length)
                                    for (var i = 0; i < message.spanEnvelope.length; ++i)
                                        writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.spanEnvelope[i]);
                                return writer;
                            };

                            /**
                             * Decodes a ClusterExportEnvelope message from the specified reader or buffer.
                             * @function decode
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterExportEnvelope
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {dynatrace.odin.proto.collector.trace.v1.ClusterExportEnvelope} ClusterExportEnvelope
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            ClusterExportEnvelope.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.collector.trace.v1.ClusterExportEnvelope();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1: {
                                            message.agentId = reader.int64();
                                            break;
                                        }
                                    case 2: {
                                            message.exportMetaInfo = reader.bytes();
                                            break;
                                        }
                                    case 3: {
                                            message.resource = reader.bytes();
                                            break;
                                        }
                                    case 4: {
                                            if (!(message.spanEnvelope && message.spanEnvelope.length))
                                                message.spanEnvelope = [];
                                            message.spanEnvelope.push(reader.bytes());
                                            break;
                                        }
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };

                            /**
                             * Gets the default type url for ClusterExportEnvelope
                             * @function getTypeUrl
                             * @memberof dynatrace.odin.proto.collector.trace.v1.ClusterExportEnvelope
                             * @static
                             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                             * @returns {string} The default type url
                             */
                            ClusterExportEnvelope.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                                if (typeUrlPrefix === undefined) {
                                    typeUrlPrefix = "type.googleapis.com";
                                }
                                return typeUrlPrefix + "/dynatrace.odin.proto.collector.trace.v1.ClusterExportEnvelope";
                            };

                            return ClusterExportEnvelope;
                        })();

                        return v1;
                    })();

                    return trace;
                })();

                collector.common = (function() {

                    /**
                     * Namespace common.
                     * @memberof dynatrace.odin.proto.collector
                     * @namespace
                     */
                    var common = {};

                    common.v1 = (function() {

                        /**
                         * Namespace v1.
                         * @memberof dynatrace.odin.proto.collector.common
                         * @namespace
                         */
                        var v1 = {};

                        v1.ExportMetaInfo = (function() {

                            /**
                             * Properties of an ExportMetaInfo.
                             * @memberof dynatrace.odin.proto.collector.common.v1
                             * @interface IExportMetaInfo
                             * @property {number|Long|null} [clusterTimeOffsetMs] ExportMetaInfo clusterTimeOffsetMs
                             * @property {dynatrace.odin.proto.collector.common.v1.ExportMetaInfo.TimeSyncMode|null} [timeSyncMode] ExportMetaInfo timeSyncMode
                             * @property {dynatrace.odin.proto.collector.common.v1.ExportMetaInfo.SemanticsVersion|null} [semanticsVersion] ExportMetaInfo semanticsVersion
                             */

                            /**
                             * Constructs a new ExportMetaInfo.
                             * @memberof dynatrace.odin.proto.collector.common.v1
                             * @classdesc Represents an ExportMetaInfo.
                             * @implements IExportMetaInfo
                             * @constructor
                             * @param {dynatrace.odin.proto.collector.common.v1.IExportMetaInfo=} [properties] Properties to set
                             */
                            function ExportMetaInfo(properties) {
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }

                            /**
                             * ExportMetaInfo clusterTimeOffsetMs.
                             * @member {number|Long} clusterTimeOffsetMs
                             * @memberof dynatrace.odin.proto.collector.common.v1.ExportMetaInfo
                             * @instance
                             */
                            ExportMetaInfo.prototype.clusterTimeOffsetMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                            /**
                             * ExportMetaInfo timeSyncMode.
                             * @member {dynatrace.odin.proto.collector.common.v1.ExportMetaInfo.TimeSyncMode} timeSyncMode
                             * @memberof dynatrace.odin.proto.collector.common.v1.ExportMetaInfo
                             * @instance
                             */
                            ExportMetaInfo.prototype.timeSyncMode = 0;

                            /**
                             * ExportMetaInfo semanticsVersion.
                             * @member {dynatrace.odin.proto.collector.common.v1.ExportMetaInfo.SemanticsVersion} semanticsVersion
                             * @memberof dynatrace.odin.proto.collector.common.v1.ExportMetaInfo
                             * @instance
                             */
                            ExportMetaInfo.prototype.semanticsVersion = 0;

                            /**
                             * Encodes the specified ExportMetaInfo message. Does not implicitly {@link dynatrace.odin.proto.collector.common.v1.ExportMetaInfo.verify|verify} messages.
                             * @function encode
                             * @memberof dynatrace.odin.proto.collector.common.v1.ExportMetaInfo
                             * @static
                             * @param {dynatrace.odin.proto.collector.common.v1.IExportMetaInfo} message ExportMetaInfo message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            ExportMetaInfo.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.clusterTimeOffsetMs != null && Object.hasOwnProperty.call(message, "clusterTimeOffsetMs"))
                                    writer.uint32(/* id 1, wireType 1 =*/9).sfixed64(message.clusterTimeOffsetMs);
                                if (message.timeSyncMode != null && Object.hasOwnProperty.call(message, "timeSyncMode"))
                                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.timeSyncMode);
                                if (message.semanticsVersion != null && Object.hasOwnProperty.call(message, "semanticsVersion"))
                                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.semanticsVersion);
                                return writer;
                            };

                            /**
                             * Decodes an ExportMetaInfo message from the specified reader or buffer.
                             * @function decode
                             * @memberof dynatrace.odin.proto.collector.common.v1.ExportMetaInfo
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {dynatrace.odin.proto.collector.common.v1.ExportMetaInfo} ExportMetaInfo
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            ExportMetaInfo.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.collector.common.v1.ExportMetaInfo();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1: {
                                            message.clusterTimeOffsetMs = reader.sfixed64();
                                            break;
                                        }
                                    case 2: {
                                            message.timeSyncMode = reader.int32();
                                            break;
                                        }
                                    case 3: {
                                            message.semanticsVersion = reader.int32();
                                            break;
                                        }
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };

                            /**
                             * Gets the default type url for ExportMetaInfo
                             * @function getTypeUrl
                             * @memberof dynatrace.odin.proto.collector.common.v1.ExportMetaInfo
                             * @static
                             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                             * @returns {string} The default type url
                             */
                            ExportMetaInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                                if (typeUrlPrefix === undefined) {
                                    typeUrlPrefix = "type.googleapis.com";
                                }
                                return typeUrlPrefix + "/dynatrace.odin.proto.collector.common.v1.ExportMetaInfo";
                            };

                            /**
                             * TimeSyncMode enum.
                             * @name dynatrace.odin.proto.collector.common.v1.ExportMetaInfo.TimeSyncMode
                             * @enum {number}
                             * @property {number} Invalid=0 Invalid value
                             * @property {number} NTPSync=1 NTPSync value
                             * @property {number} ClusterSync=2 ClusterSync value
                             * @property {number} FailedSync=3 FailedSync value
                             * @property {number} Unsynced=4 Unsynced value
                             */
                            ExportMetaInfo.TimeSyncMode = (function() {
                                var valuesById = {}, values = Object.create(valuesById);
                                values[valuesById[0] = "Invalid"] = 0;
                                values[valuesById[1] = "NTPSync"] = 1;
                                values[valuesById[2] = "ClusterSync"] = 2;
                                values[valuesById[3] = "FailedSync"] = 3;
                                values[valuesById[4] = "Unsynced"] = 4;
                                return values;
                            })();

                            /**
                             * SemanticsVersion enum.
                             * @name dynatrace.odin.proto.collector.common.v1.ExportMetaInfo.SemanticsVersion
                             * @enum {number}
                             * @property {number} V0=0 V0 value
                             * @property {number} V1=1 V1 value
                             */
                            ExportMetaInfo.SemanticsVersion = (function() {
                                var valuesById = {}, values = Object.create(valuesById);
                                values[valuesById[0] = "V0"] = 0;
                                values[valuesById[1] = "V1"] = 1;
                                return values;
                            })();

                            return ExportMetaInfo;
                        })();

                        return v1;
                    })();

                    return common;
                })();

                return collector;
            })();

            proto.trace = (function() {

                /**
                 * Namespace trace.
                 * @memberof dynatrace.odin.proto
                 * @namespace
                 */
                var trace = {};

                trace.v1 = (function() {

                    /**
                     * Namespace v1.
                     * @memberof dynatrace.odin.proto.trace
                     * @namespace
                     */
                    var v1 = {};

                    v1.CustomTag = (function() {

                        /**
                         * Properties of a CustomTag.
                         * @memberof dynatrace.odin.proto.trace.v1
                         * @interface ICustomTag
                         * @property {dynatrace.odin.proto.trace.v1.CustomTag.Type|null} [type] CustomTag type
                         * @property {dynatrace.odin.proto.trace.v1.CustomTag.Direction|null} [direction] CustomTag direction
                         * @property {Uint8Array|null} [tagValue] CustomTag tagValue
                         */

                        /**
                         * Constructs a new CustomTag.
                         * @memberof dynatrace.odin.proto.trace.v1
                         * @classdesc Represents a CustomTag.
                         * @implements ICustomTag
                         * @constructor
                         * @param {dynatrace.odin.proto.trace.v1.ICustomTag=} [properties] Properties to set
                         */
                        function CustomTag(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * CustomTag type.
                         * @member {dynatrace.odin.proto.trace.v1.CustomTag.Type} type
                         * @memberof dynatrace.odin.proto.trace.v1.CustomTag
                         * @instance
                         */
                        CustomTag.prototype.type = 0;

                        /**
                         * CustomTag direction.
                         * @member {dynatrace.odin.proto.trace.v1.CustomTag.Direction} direction
                         * @memberof dynatrace.odin.proto.trace.v1.CustomTag
                         * @instance
                         */
                        CustomTag.prototype.direction = 0;

                        /**
                         * CustomTag tagValue.
                         * @member {Uint8Array} tagValue
                         * @memberof dynatrace.odin.proto.trace.v1.CustomTag
                         * @instance
                         */
                        CustomTag.prototype.tagValue = $util.newBuffer([]);

                        /**
                         * Encodes the specified CustomTag message. Does not implicitly {@link dynatrace.odin.proto.trace.v1.CustomTag.verify|verify} messages.
                         * @function encode
                         * @memberof dynatrace.odin.proto.trace.v1.CustomTag
                         * @static
                         * @param {dynatrace.odin.proto.trace.v1.ICustomTag} message CustomTag message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CustomTag.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                            if (message.direction != null && Object.hasOwnProperty.call(message, "direction"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.direction);
                            if (message.tagValue != null && Object.hasOwnProperty.call(message, "tagValue"))
                                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.tagValue);
                            return writer;
                        };

                        /**
                         * Decodes a CustomTag message from the specified reader or buffer.
                         * @function decode
                         * @memberof dynatrace.odin.proto.trace.v1.CustomTag
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {dynatrace.odin.proto.trace.v1.CustomTag} CustomTag
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CustomTag.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.trace.v1.CustomTag();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.type = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.direction = reader.int32();
                                        break;
                                    }
                                case 3: {
                                        message.tagValue = reader.bytes();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Gets the default type url for CustomTag
                         * @function getTypeUrl
                         * @memberof dynatrace.odin.proto.trace.v1.CustomTag
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        CustomTag.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/dynatrace.odin.proto.trace.v1.CustomTag";
                        };

                        /**
                         * Type enum.
                         * @name dynatrace.odin.proto.trace.v1.CustomTag.Type
                         * @enum {number}
                         * @property {number} Generic=0 Generic value
                         * @property {number} MQ=1 MQ value
                         */
                        CustomTag.Type = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "Generic"] = 0;
                            values[valuesById[1] = "MQ"] = 1;
                            return values;
                        })();

                        /**
                         * Direction enum.
                         * @name dynatrace.odin.proto.trace.v1.CustomTag.Direction
                         * @enum {number}
                         * @property {number} InvalidDirection=0 InvalidDirection value
                         * @property {number} Incoming=1 Incoming value
                         * @property {number} Outgoing=2 Outgoing value
                         */
                        CustomTag.Direction = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "InvalidDirection"] = 0;
                            values[valuesById[1] = "Incoming"] = 1;
                            values[valuesById[2] = "Outgoing"] = 2;
                            return values;
                        })();

                        return CustomTag;
                    })();

                    v1.Span = (function() {

                        /**
                         * Properties of a Span.
                         * @memberof dynatrace.odin.proto.trace.v1
                         * @interface ISpan
                         * @property {Uint8Array|null} [trace_id] Span trace_id
                         * @property {Uint8Array|null} [span_id] Span span_id
                         * @property {string|null} [tracestate] Span tracestate
                         * @property {Uint8Array|null} [parent_span_id] Span parent_span_id
                         * @property {string|null} [name] Span name
                         * @property {dynatrace.odin.proto.trace.v1.Span.SpanKind|null} [kind] Span kind
                         * @property {number|Long|null} [start_time_unixnano] Span start_time_unixnano
                         * @property {number|Long|null} [end_time_unixnano] Span end_time_unixnano
                         * @property {Array.<dynatrace.odin.proto.common.v1.IAttributeKeyValue>|null} [attributes] Span attributes
                         * @property {number|null} [dropped_attributes_count] Span dropped_attributes_count
                         * @property {Array.<dynatrace.odin.proto.trace.v1.Span.IEvent>|null} [events] Span events
                         * @property {number|null} [dropped_events_count] Span dropped_events_count
                         * @property {Array.<dynatrace.odin.proto.trace.v1.Span.ILink>|null} [links] Span links
                         * @property {number|null} [dropped_links_count] Span dropped_links_count
                         * @property {dynatrace.odin.proto.trace.v1.IStatus|null} [status] Span status
                         * @property {dynatrace.odin.proto.trace.v1.Span.SendReason|null} [send_reason] Span send_reason
                         * @property {number|null} [update_sequence_no] Span update_sequence_no
                         * @property {number|Long|null} [last_propagate_time_unixnano] Span last_propagate_time_unixnano
                         * @property {Uint8Array|null} [tenant_parent_span_id] Span tenant_parent_span_id
                         * @property {string|null} [mobile_tag] Span mobile_tag
                         * @property {dynatrace.odin.proto.trace.v1.ICustomTag|null} [custom_tag] Span custom_tag
                         * @property {number|null} [parent_fwtag_encoded_link_id] Span parent_fwtag_encoded_link_id
                         */

                        /**
                         * Constructs a new Span.
                         * @memberof dynatrace.odin.proto.trace.v1
                         * @classdesc Represents a Span.
                         * @implements ISpan
                         * @constructor
                         * @param {dynatrace.odin.proto.trace.v1.ISpan=} [properties] Properties to set
                         */
                        function Span(properties) {
                            this.attributes = [];
                            this.events = [];
                            this.links = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Span trace_id.
                         * @member {Uint8Array} trace_id
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.trace_id = $util.newBuffer([]);

                        /**
                         * Span span_id.
                         * @member {Uint8Array} span_id
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.span_id = $util.newBuffer([]);

                        /**
                         * Span tracestate.
                         * @member {string} tracestate
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.tracestate = "";

                        /**
                         * Span parent_span_id.
                         * @member {Uint8Array} parent_span_id
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.parent_span_id = $util.newBuffer([]);

                        /**
                         * Span name.
                         * @member {string} name
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.name = "";

                        /**
                         * Span kind.
                         * @member {dynatrace.odin.proto.trace.v1.Span.SpanKind} kind
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.kind = 0;

                        /**
                         * Span start_time_unixnano.
                         * @member {number|Long} start_time_unixnano
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.start_time_unixnano = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Span end_time_unixnano.
                         * @member {number|Long} end_time_unixnano
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.end_time_unixnano = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Span attributes.
                         * @member {Array.<dynatrace.odin.proto.common.v1.IAttributeKeyValue>} attributes
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.attributes = $util.emptyArray;

                        /**
                         * Span dropped_attributes_count.
                         * @member {number} dropped_attributes_count
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.dropped_attributes_count = 0;

                        /**
                         * Span events.
                         * @member {Array.<dynatrace.odin.proto.trace.v1.Span.IEvent>} events
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.events = $util.emptyArray;

                        /**
                         * Span dropped_events_count.
                         * @member {number} dropped_events_count
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.dropped_events_count = 0;

                        /**
                         * Span links.
                         * @member {Array.<dynatrace.odin.proto.trace.v1.Span.ILink>} links
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.links = $util.emptyArray;

                        /**
                         * Span dropped_links_count.
                         * @member {number} dropped_links_count
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.dropped_links_count = 0;

                        /**
                         * Span status.
                         * @member {dynatrace.odin.proto.trace.v1.IStatus|null|undefined} status
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.status = null;

                        /**
                         * Span send_reason.
                         * @member {dynatrace.odin.proto.trace.v1.Span.SendReason} send_reason
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.send_reason = 0;

                        /**
                         * Span update_sequence_no.
                         * @member {number} update_sequence_no
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.update_sequence_no = 0;

                        /**
                         * Span last_propagate_time_unixnano.
                         * @member {number|Long} last_propagate_time_unixnano
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.last_propagate_time_unixnano = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Span tenant_parent_span_id.
                         * @member {Uint8Array} tenant_parent_span_id
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.tenant_parent_span_id = $util.newBuffer([]);

                        /**
                         * Span mobile_tag.
                         * @member {string} mobile_tag
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.mobile_tag = "";

                        /**
                         * Span custom_tag.
                         * @member {dynatrace.odin.proto.trace.v1.ICustomTag|null|undefined} custom_tag
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.custom_tag = null;

                        /**
                         * Span parent_fwtag_encoded_link_id.
                         * @member {number|null|undefined} parent_fwtag_encoded_link_id
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Span.prototype.parent_fwtag_encoded_link_id = null;

                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;

                        /**
                         * Span _parent_fwtag_encoded_link_id.
                         * @member {"parent_fwtag_encoded_link_id"|undefined} _parent_fwtag_encoded_link_id
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @instance
                         */
                        Object.defineProperty(Span.prototype, "_parent_fwtag_encoded_link_id", {
                            get: $util.oneOfGetter($oneOfFields = ["parent_fwtag_encoded_link_id"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * Encodes the specified Span message. Does not implicitly {@link dynatrace.odin.proto.trace.v1.Span.verify|verify} messages.
                         * @function encode
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @static
                         * @param {dynatrace.odin.proto.trace.v1.ISpan} message Span message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Span.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.trace_id != null && Object.hasOwnProperty.call(message, "trace_id"))
                                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.trace_id);
                            if (message.span_id != null && Object.hasOwnProperty.call(message, "span_id"))
                                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.span_id);
                            if (message.tracestate != null && Object.hasOwnProperty.call(message, "tracestate"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.tracestate);
                            if (message.parent_span_id != null && Object.hasOwnProperty.call(message, "parent_span_id"))
                                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.parent_span_id);
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.name);
                            if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.kind);
                            if (message.start_time_unixnano != null && Object.hasOwnProperty.call(message, "start_time_unixnano"))
                                writer.uint32(/* id 7, wireType 1 =*/57).fixed64(message.start_time_unixnano);
                            if (message.end_time_unixnano != null && Object.hasOwnProperty.call(message, "end_time_unixnano"))
                                writer.uint32(/* id 8, wireType 1 =*/65).fixed64(message.end_time_unixnano);
                            if (message.attributes != null && message.attributes.length)
                                for (var i = 0; i < message.attributes.length; ++i)
                                    $root.dynatrace.odin.proto.common.v1.AttributeKeyValue.encode(message.attributes[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                            if (message.dropped_attributes_count != null && Object.hasOwnProperty.call(message, "dropped_attributes_count"))
                                writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.dropped_attributes_count);
                            if (message.events != null && message.events.length)
                                for (var i = 0; i < message.events.length; ++i)
                                    $root.dynatrace.odin.proto.trace.v1.Span.Event.encode(message.events[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                            if (message.dropped_events_count != null && Object.hasOwnProperty.call(message, "dropped_events_count"))
                                writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.dropped_events_count);
                            if (message.links != null && message.links.length)
                                for (var i = 0; i < message.links.length; ++i)
                                    $root.dynatrace.odin.proto.trace.v1.Span.Link.encode(message.links[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                            if (message.dropped_links_count != null && Object.hasOwnProperty.call(message, "dropped_links_count"))
                                writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.dropped_links_count);
                            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                                $root.dynatrace.odin.proto.trace.v1.Status.encode(message.status, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                            if (message.send_reason != null && Object.hasOwnProperty.call(message, "send_reason"))
                                writer.uint32(/* id 32, wireType 0 =*/256).int32(message.send_reason);
                            if (message.update_sequence_no != null && Object.hasOwnProperty.call(message, "update_sequence_no"))
                                writer.uint32(/* id 33, wireType 0 =*/264).int32(message.update_sequence_no);
                            if (message.last_propagate_time_unixnano != null && Object.hasOwnProperty.call(message, "last_propagate_time_unixnano"))
                                writer.uint32(/* id 34, wireType 1 =*/273).fixed64(message.last_propagate_time_unixnano);
                            if (message.tenant_parent_span_id != null && Object.hasOwnProperty.call(message, "tenant_parent_span_id"))
                                writer.uint32(/* id 35, wireType 2 =*/282).bytes(message.tenant_parent_span_id);
                            if (message.mobile_tag != null && Object.hasOwnProperty.call(message, "mobile_tag"))
                                writer.uint32(/* id 36, wireType 2 =*/290).string(message.mobile_tag);
                            if (message.custom_tag != null && Object.hasOwnProperty.call(message, "custom_tag"))
                                $root.dynatrace.odin.proto.trace.v1.CustomTag.encode(message.custom_tag, writer.uint32(/* id 37, wireType 2 =*/298).fork()).ldelim();
                            if (message.parent_fwtag_encoded_link_id != null && Object.hasOwnProperty.call(message, "parent_fwtag_encoded_link_id"))
                                writer.uint32(/* id 38, wireType 0 =*/304).int32(message.parent_fwtag_encoded_link_id);
                            return writer;
                        };

                        /**
                         * Decodes a Span message from the specified reader or buffer.
                         * @function decode
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {dynatrace.odin.proto.trace.v1.Span} Span
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Span.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.trace.v1.Span();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.trace_id = reader.bytes();
                                        break;
                                    }
                                case 2: {
                                        message.span_id = reader.bytes();
                                        break;
                                    }
                                case 3: {
                                        message.tracestate = reader.string();
                                        break;
                                    }
                                case 4: {
                                        message.parent_span_id = reader.bytes();
                                        break;
                                    }
                                case 5: {
                                        message.name = reader.string();
                                        break;
                                    }
                                case 6: {
                                        message.kind = reader.int32();
                                        break;
                                    }
                                case 7: {
                                        message.start_time_unixnano = reader.fixed64();
                                        break;
                                    }
                                case 8: {
                                        message.end_time_unixnano = reader.fixed64();
                                        break;
                                    }
                                case 9: {
                                        if (!(message.attributes && message.attributes.length))
                                            message.attributes = [];
                                        message.attributes.push($root.dynatrace.odin.proto.common.v1.AttributeKeyValue.decode(reader, reader.uint32()));
                                        break;
                                    }
                                case 10: {
                                        message.dropped_attributes_count = reader.uint32();
                                        break;
                                    }
                                case 11: {
                                        if (!(message.events && message.events.length))
                                            message.events = [];
                                        message.events.push($root.dynatrace.odin.proto.trace.v1.Span.Event.decode(reader, reader.uint32()));
                                        break;
                                    }
                                case 12: {
                                        message.dropped_events_count = reader.uint32();
                                        break;
                                    }
                                case 13: {
                                        if (!(message.links && message.links.length))
                                            message.links = [];
                                        message.links.push($root.dynatrace.odin.proto.trace.v1.Span.Link.decode(reader, reader.uint32()));
                                        break;
                                    }
                                case 14: {
                                        message.dropped_links_count = reader.uint32();
                                        break;
                                    }
                                case 15: {
                                        message.status = $root.dynatrace.odin.proto.trace.v1.Status.decode(reader, reader.uint32());
                                        break;
                                    }
                                case 32: {
                                        message.send_reason = reader.int32();
                                        break;
                                    }
                                case 33: {
                                        message.update_sequence_no = reader.int32();
                                        break;
                                    }
                                case 34: {
                                        message.last_propagate_time_unixnano = reader.fixed64();
                                        break;
                                    }
                                case 35: {
                                        message.tenant_parent_span_id = reader.bytes();
                                        break;
                                    }
                                case 36: {
                                        message.mobile_tag = reader.string();
                                        break;
                                    }
                                case 37: {
                                        message.custom_tag = $root.dynatrace.odin.proto.trace.v1.CustomTag.decode(reader, reader.uint32());
                                        break;
                                    }
                                case 38: {
                                        message.parent_fwtag_encoded_link_id = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Gets the default type url for Span
                         * @function getTypeUrl
                         * @memberof dynatrace.odin.proto.trace.v1.Span
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Span.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/dynatrace.odin.proto.trace.v1.Span";
                        };

                        /**
                         * SpanKind enum.
                         * @name dynatrace.odin.proto.trace.v1.Span.SpanKind
                         * @enum {number}
                         * @property {number} SPAN_KIND_UNSPECIFIED=0 SPAN_KIND_UNSPECIFIED value
                         * @property {number} INTERNAL=1 INTERNAL value
                         * @property {number} SERVER=2 SERVER value
                         * @property {number} CLIENT=3 CLIENT value
                         * @property {number} PRODUCER=4 PRODUCER value
                         * @property {number} CONSUMER=5 CONSUMER value
                         * @property {number} LINK=6 LINK value
                         */
                        Span.SpanKind = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "SPAN_KIND_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "INTERNAL"] = 1;
                            values[valuesById[2] = "SERVER"] = 2;
                            values[valuesById[3] = "CLIENT"] = 3;
                            values[valuesById[4] = "PRODUCER"] = 4;
                            values[valuesById[5] = "CONSUMER"] = 5;
                            values[valuesById[6] = "LINK"] = 6;
                            return values;
                        })();

                        Span.Event = (function() {

                            /**
                             * Properties of an Event.
                             * @memberof dynatrace.odin.proto.trace.v1.Span
                             * @interface IEvent
                             * @property {number|Long|null} [time_unixnano] Event time_unixnano
                             * @property {string|null} [name] Event name
                             * @property {Array.<dynatrace.odin.proto.common.v1.IAttributeKeyValue>|null} [attributes] Event attributes
                             * @property {number|null} [dropped_attributes_count] Event dropped_attributes_count
                             */

                            /**
                             * Constructs a new Event.
                             * @memberof dynatrace.odin.proto.trace.v1.Span
                             * @classdesc Represents an Event.
                             * @implements IEvent
                             * @constructor
                             * @param {dynatrace.odin.proto.trace.v1.Span.IEvent=} [properties] Properties to set
                             */
                            function Event(properties) {
                                this.attributes = [];
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }

                            /**
                             * Event time_unixnano.
                             * @member {number|Long} time_unixnano
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Event
                             * @instance
                             */
                            Event.prototype.time_unixnano = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                            /**
                             * Event name.
                             * @member {string} name
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Event
                             * @instance
                             */
                            Event.prototype.name = "";

                            /**
                             * Event attributes.
                             * @member {Array.<dynatrace.odin.proto.common.v1.IAttributeKeyValue>} attributes
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Event
                             * @instance
                             */
                            Event.prototype.attributes = $util.emptyArray;

                            /**
                             * Event dropped_attributes_count.
                             * @member {number} dropped_attributes_count
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Event
                             * @instance
                             */
                            Event.prototype.dropped_attributes_count = 0;

                            /**
                             * Encodes the specified Event message. Does not implicitly {@link dynatrace.odin.proto.trace.v1.Span.Event.verify|verify} messages.
                             * @function encode
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Event
                             * @static
                             * @param {dynatrace.odin.proto.trace.v1.Span.IEvent} message Event message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            Event.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.time_unixnano != null && Object.hasOwnProperty.call(message, "time_unixnano"))
                                    writer.uint32(/* id 1, wireType 1 =*/9).fixed64(message.time_unixnano);
                                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                                if (message.attributes != null && message.attributes.length)
                                    for (var i = 0; i < message.attributes.length; ++i)
                                        $root.dynatrace.odin.proto.common.v1.AttributeKeyValue.encode(message.attributes[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                                if (message.dropped_attributes_count != null && Object.hasOwnProperty.call(message, "dropped_attributes_count"))
                                    writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.dropped_attributes_count);
                                return writer;
                            };

                            /**
                             * Decodes an Event message from the specified reader or buffer.
                             * @function decode
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Event
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {dynatrace.odin.proto.trace.v1.Span.Event} Event
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            Event.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.trace.v1.Span.Event();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1: {
                                            message.time_unixnano = reader.fixed64();
                                            break;
                                        }
                                    case 2: {
                                            message.name = reader.string();
                                            break;
                                        }
                                    case 3: {
                                            if (!(message.attributes && message.attributes.length))
                                                message.attributes = [];
                                            message.attributes.push($root.dynatrace.odin.proto.common.v1.AttributeKeyValue.decode(reader, reader.uint32()));
                                            break;
                                        }
                                    case 4: {
                                            message.dropped_attributes_count = reader.uint32();
                                            break;
                                        }
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };

                            /**
                             * Gets the default type url for Event
                             * @function getTypeUrl
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Event
                             * @static
                             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                             * @returns {string} The default type url
                             */
                            Event.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                                if (typeUrlPrefix === undefined) {
                                    typeUrlPrefix = "type.googleapis.com";
                                }
                                return typeUrlPrefix + "/dynatrace.odin.proto.trace.v1.Span.Event";
                            };

                            return Event;
                        })();

                        Span.Link = (function() {

                            /**
                             * Properties of a Link.
                             * @memberof dynatrace.odin.proto.trace.v1.Span
                             * @interface ILink
                             * @property {Uint8Array|null} [trace_id] Link trace_id
                             * @property {Uint8Array|null} [span_id] Link span_id
                             * @property {string|null} [tracestate] Link tracestate
                             * @property {Array.<dynatrace.odin.proto.common.v1.IAttributeKeyValue>|null} [attributes] Link attributes
                             * @property {number|null} [dropped_attributes_count] Link dropped_attributes_count
                             * @property {number|null} [fwtag_encoded_link_id] Link fwtag_encoded_link_id
                             */

                            /**
                             * Constructs a new Link.
                             * @memberof dynatrace.odin.proto.trace.v1.Span
                             * @classdesc Represents a Link.
                             * @implements ILink
                             * @constructor
                             * @param {dynatrace.odin.proto.trace.v1.Span.ILink=} [properties] Properties to set
                             */
                            function Link(properties) {
                                this.attributes = [];
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }

                            /**
                             * Link trace_id.
                             * @member {Uint8Array} trace_id
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Link
                             * @instance
                             */
                            Link.prototype.trace_id = $util.newBuffer([]);

                            /**
                             * Link span_id.
                             * @member {Uint8Array} span_id
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Link
                             * @instance
                             */
                            Link.prototype.span_id = $util.newBuffer([]);

                            /**
                             * Link tracestate.
                             * @member {string} tracestate
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Link
                             * @instance
                             */
                            Link.prototype.tracestate = "";

                            /**
                             * Link attributes.
                             * @member {Array.<dynatrace.odin.proto.common.v1.IAttributeKeyValue>} attributes
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Link
                             * @instance
                             */
                            Link.prototype.attributes = $util.emptyArray;

                            /**
                             * Link dropped_attributes_count.
                             * @member {number} dropped_attributes_count
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Link
                             * @instance
                             */
                            Link.prototype.dropped_attributes_count = 0;

                            /**
                             * Link fwtag_encoded_link_id.
                             * @member {number|null|undefined} fwtag_encoded_link_id
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Link
                             * @instance
                             */
                            Link.prototype.fwtag_encoded_link_id = null;

                            // OneOf field names bound to virtual getters and setters
                            var $oneOfFields;

                            /**
                             * Link _fwtag_encoded_link_id.
                             * @member {"fwtag_encoded_link_id"|undefined} _fwtag_encoded_link_id
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Link
                             * @instance
                             */
                            Object.defineProperty(Link.prototype, "_fwtag_encoded_link_id", {
                                get: $util.oneOfGetter($oneOfFields = ["fwtag_encoded_link_id"]),
                                set: $util.oneOfSetter($oneOfFields)
                            });

                            /**
                             * Encodes the specified Link message. Does not implicitly {@link dynatrace.odin.proto.trace.v1.Span.Link.verify|verify} messages.
                             * @function encode
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Link
                             * @static
                             * @param {dynatrace.odin.proto.trace.v1.Span.ILink} message Link message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            Link.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.trace_id != null && Object.hasOwnProperty.call(message, "trace_id"))
                                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.trace_id);
                                if (message.span_id != null && Object.hasOwnProperty.call(message, "span_id"))
                                    writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.span_id);
                                if (message.tracestate != null && Object.hasOwnProperty.call(message, "tracestate"))
                                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.tracestate);
                                if (message.attributes != null && message.attributes.length)
                                    for (var i = 0; i < message.attributes.length; ++i)
                                        $root.dynatrace.odin.proto.common.v1.AttributeKeyValue.encode(message.attributes[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                                if (message.dropped_attributes_count != null && Object.hasOwnProperty.call(message, "dropped_attributes_count"))
                                    writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.dropped_attributes_count);
                                if (message.fwtag_encoded_link_id != null && Object.hasOwnProperty.call(message, "fwtag_encoded_link_id"))
                                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.fwtag_encoded_link_id);
                                return writer;
                            };

                            /**
                             * Decodes a Link message from the specified reader or buffer.
                             * @function decode
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Link
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {dynatrace.odin.proto.trace.v1.Span.Link} Link
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            Link.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.trace.v1.Span.Link();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1: {
                                            message.trace_id = reader.bytes();
                                            break;
                                        }
                                    case 2: {
                                            message.span_id = reader.bytes();
                                            break;
                                        }
                                    case 3: {
                                            message.tracestate = reader.string();
                                            break;
                                        }
                                    case 4: {
                                            if (!(message.attributes && message.attributes.length))
                                                message.attributes = [];
                                            message.attributes.push($root.dynatrace.odin.proto.common.v1.AttributeKeyValue.decode(reader, reader.uint32()));
                                            break;
                                        }
                                    case 5: {
                                            message.dropped_attributes_count = reader.uint32();
                                            break;
                                        }
                                    case 6: {
                                            message.fwtag_encoded_link_id = reader.int32();
                                            break;
                                        }
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };

                            /**
                             * Gets the default type url for Link
                             * @function getTypeUrl
                             * @memberof dynatrace.odin.proto.trace.v1.Span.Link
                             * @static
                             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                             * @returns {string} The default type url
                             */
                            Link.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                                if (typeUrlPrefix === undefined) {
                                    typeUrlPrefix = "type.googleapis.com";
                                }
                                return typeUrlPrefix + "/dynatrace.odin.proto.trace.v1.Span.Link";
                            };

                            return Link;
                        })();

                        /**
                         * SendReason enum.
                         * @name dynatrace.odin.proto.trace.v1.Span.SendReason
                         * @enum {number}
                         * @property {number} Ended=0 Ended value
                         * @property {number} NewOrChanged=1 NewOrChanged value
                         * @property {number} KeepAlive=2 KeepAlive value
                         * @property {number} Dropped=3 Dropped value
                         */
                        Span.SendReason = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "Ended"] = 0;
                            values[valuesById[1] = "NewOrChanged"] = 1;
                            values[valuesById[2] = "KeepAlive"] = 2;
                            values[valuesById[3] = "Dropped"] = 3;
                            return values;
                        })();

                        return Span;
                    })();

                    v1.Status = (function() {

                        /**
                         * Properties of a Status.
                         * @memberof dynatrace.odin.proto.trace.v1
                         * @interface IStatus
                         * @property {dynatrace.odin.proto.trace.v1.Status.StatusCode|null} [code] Status code
                         * @property {string|null} [message] Status message
                         */

                        /**
                         * Constructs a new Status.
                         * @memberof dynatrace.odin.proto.trace.v1
                         * @classdesc Represents a Status.
                         * @implements IStatus
                         * @constructor
                         * @param {dynatrace.odin.proto.trace.v1.IStatus=} [properties] Properties to set
                         */
                        function Status(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Status code.
                         * @member {dynatrace.odin.proto.trace.v1.Status.StatusCode} code
                         * @memberof dynatrace.odin.proto.trace.v1.Status
                         * @instance
                         */
                        Status.prototype.code = 0;

                        /**
                         * Status message.
                         * @member {string} message
                         * @memberof dynatrace.odin.proto.trace.v1.Status
                         * @instance
                         */
                        Status.prototype.message = "";

                        /**
                         * Encodes the specified Status message. Does not implicitly {@link dynatrace.odin.proto.trace.v1.Status.verify|verify} messages.
                         * @function encode
                         * @memberof dynatrace.odin.proto.trace.v1.Status
                         * @static
                         * @param {dynatrace.odin.proto.trace.v1.IStatus} message Status message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Status.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                            return writer;
                        };

                        /**
                         * Decodes a Status message from the specified reader or buffer.
                         * @function decode
                         * @memberof dynatrace.odin.proto.trace.v1.Status
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {dynatrace.odin.proto.trace.v1.Status} Status
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Status.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.trace.v1.Status();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.code = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.message = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Gets the default type url for Status
                         * @function getTypeUrl
                         * @memberof dynatrace.odin.proto.trace.v1.Status
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Status.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/dynatrace.odin.proto.trace.v1.Status";
                        };

                        /**
                         * StatusCode enum.
                         * @name dynatrace.odin.proto.trace.v1.Status.StatusCode
                         * @enum {number}
                         * @property {number} Ok=0 Ok value
                         * @property {number} Cancelled=1 Cancelled value
                         * @property {number} UnknownError=2 UnknownError value
                         * @property {number} InvalidArgument=3 InvalidArgument value
                         * @property {number} DeadlineExceeded=4 DeadlineExceeded value
                         * @property {number} NotFound=5 NotFound value
                         * @property {number} AlreadyExists=6 AlreadyExists value
                         * @property {number} PermissionDenied=7 PermissionDenied value
                         * @property {number} ResourceExhausted=8 ResourceExhausted value
                         * @property {number} FailedPrecondition=9 FailedPrecondition value
                         * @property {number} Aborted=10 Aborted value
                         * @property {number} OutOfRange=11 OutOfRange value
                         * @property {number} Unimplemented=12 Unimplemented value
                         * @property {number} InternalError=13 InternalError value
                         * @property {number} Unavailable=14 Unavailable value
                         * @property {number} DataLoss=15 DataLoss value
                         * @property {number} Unauthenticated=16 Unauthenticated value
                         */
                        Status.StatusCode = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "Ok"] = 0;
                            values[valuesById[1] = "Cancelled"] = 1;
                            values[valuesById[2] = "UnknownError"] = 2;
                            values[valuesById[3] = "InvalidArgument"] = 3;
                            values[valuesById[4] = "DeadlineExceeded"] = 4;
                            values[valuesById[5] = "NotFound"] = 5;
                            values[valuesById[6] = "AlreadyExists"] = 6;
                            values[valuesById[7] = "PermissionDenied"] = 7;
                            values[valuesById[8] = "ResourceExhausted"] = 8;
                            values[valuesById[9] = "FailedPrecondition"] = 9;
                            values[valuesById[10] = "Aborted"] = 10;
                            values[valuesById[11] = "OutOfRange"] = 11;
                            values[valuesById[12] = "Unimplemented"] = 12;
                            values[valuesById[13] = "InternalError"] = 13;
                            values[valuesById[14] = "Unavailable"] = 14;
                            values[valuesById[15] = "DataLoss"] = 15;
                            values[valuesById[16] = "Unauthenticated"] = 16;
                            return values;
                        })();

                        return Status;
                    })();

                    return v1;
                })();

                return trace;
            })();

            proto.common = (function() {

                /**
                 * Namespace common.
                 * @memberof dynatrace.odin.proto
                 * @namespace
                 */
                var common = {};

                common.v1 = (function() {

                    /**
                     * Namespace v1.
                     * @memberof dynatrace.odin.proto.common
                     * @namespace
                     */
                    var v1 = {};

                    v1.AttributeKeyValue = (function() {

                        /**
                         * Properties of an AttributeKeyValue.
                         * @memberof dynatrace.odin.proto.common.v1
                         * @interface IAttributeKeyValue
                         * @property {string|null} [key] AttributeKeyValue key
                         * @property {dynatrace.odin.proto.common.v1.AttributeKeyValue.ValueType|null} [type] AttributeKeyValue type
                         * @property {string|null} [string_value] AttributeKeyValue string_value
                         * @property {number|Long|null} [int_value] AttributeKeyValue int_value
                         * @property {number|null} [double_value] AttributeKeyValue double_value
                         * @property {boolean|null} [bool_value] AttributeKeyValue bool_value
                         * @property {Array.<string>|null} [string_values] AttributeKeyValue string_values
                         * @property {Array.<number|Long>|null} [int_values] AttributeKeyValue int_values
                         * @property {Array.<number>|null} [double_values] AttributeKeyValue double_values
                         * @property {Array.<boolean>|null} [bool_values] AttributeKeyValue bool_values
                         * @property {dynatrace.odin.proto.common.v1.AttributeKeyValue.IMapValue|null} [map_value] AttributeKeyValue map_value
                         * @property {Array.<dynatrace.odin.proto.common.v1.AttributeKeyValue.IMapValue>|null} [map_values] AttributeKeyValue map_values
                         */

                        /**
                         * Constructs a new AttributeKeyValue.
                         * @memberof dynatrace.odin.proto.common.v1
                         * @classdesc Represents an AttributeKeyValue.
                         * @implements IAttributeKeyValue
                         * @constructor
                         * @param {dynatrace.odin.proto.common.v1.IAttributeKeyValue=} [properties] Properties to set
                         */
                        function AttributeKeyValue(properties) {
                            this.string_values = [];
                            this.int_values = [];
                            this.double_values = [];
                            this.bool_values = [];
                            this.map_values = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * AttributeKeyValue key.
                         * @member {string} key
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @instance
                         */
                        AttributeKeyValue.prototype.key = "";

                        /**
                         * AttributeKeyValue type.
                         * @member {dynatrace.odin.proto.common.v1.AttributeKeyValue.ValueType} type
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @instance
                         */
                        AttributeKeyValue.prototype.type = 0;

                        /**
                         * AttributeKeyValue string_value.
                         * @member {string} string_value
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @instance
                         */
                        AttributeKeyValue.prototype.string_value = "";

                        /**
                         * AttributeKeyValue int_value.
                         * @member {number|Long} int_value
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @instance
                         */
                        AttributeKeyValue.prototype.int_value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * AttributeKeyValue double_value.
                         * @member {number} double_value
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @instance
                         */
                        AttributeKeyValue.prototype.double_value = 0;

                        /**
                         * AttributeKeyValue bool_value.
                         * @member {boolean} bool_value
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @instance
                         */
                        AttributeKeyValue.prototype.bool_value = false;

                        /**
                         * AttributeKeyValue string_values.
                         * @member {Array.<string>} string_values
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @instance
                         */
                        AttributeKeyValue.prototype.string_values = $util.emptyArray;

                        /**
                         * AttributeKeyValue int_values.
                         * @member {Array.<number|Long>} int_values
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @instance
                         */
                        AttributeKeyValue.prototype.int_values = $util.emptyArray;

                        /**
                         * AttributeKeyValue double_values.
                         * @member {Array.<number>} double_values
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @instance
                         */
                        AttributeKeyValue.prototype.double_values = $util.emptyArray;

                        /**
                         * AttributeKeyValue bool_values.
                         * @member {Array.<boolean>} bool_values
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @instance
                         */
                        AttributeKeyValue.prototype.bool_values = $util.emptyArray;

                        /**
                         * AttributeKeyValue map_value.
                         * @member {dynatrace.odin.proto.common.v1.AttributeKeyValue.IMapValue|null|undefined} map_value
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @instance
                         */
                        AttributeKeyValue.prototype.map_value = null;

                        /**
                         * AttributeKeyValue map_values.
                         * @member {Array.<dynatrace.odin.proto.common.v1.AttributeKeyValue.IMapValue>} map_values
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @instance
                         */
                        AttributeKeyValue.prototype.map_values = $util.emptyArray;

                        /**
                         * Encodes the specified AttributeKeyValue message. Does not implicitly {@link dynatrace.odin.proto.common.v1.AttributeKeyValue.verify|verify} messages.
                         * @function encode
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @static
                         * @param {dynatrace.odin.proto.common.v1.IAttributeKeyValue} message AttributeKeyValue message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AttributeKeyValue.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                            if (message.string_value != null && Object.hasOwnProperty.call(message, "string_value"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.string_value);
                            if (message.int_value != null && Object.hasOwnProperty.call(message, "int_value"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.int_value);
                            if (message.double_value != null && Object.hasOwnProperty.call(message, "double_value"))
                                writer.uint32(/* id 5, wireType 1 =*/41).double(message.double_value);
                            if (message.bool_value != null && Object.hasOwnProperty.call(message, "bool_value"))
                                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.bool_value);
                            if (message.string_values != null && message.string_values.length)
                                for (var i = 0; i < message.string_values.length; ++i)
                                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.string_values[i]);
                            if (message.int_values != null && message.int_values.length) {
                                writer.uint32(/* id 8, wireType 2 =*/66).fork();
                                for (var i = 0; i < message.int_values.length; ++i)
                                    writer.int64(message.int_values[i]);
                                writer.ldelim();
                            }
                            if (message.double_values != null && message.double_values.length) {
                                writer.uint32(/* id 9, wireType 2 =*/74).fork();
                                for (var i = 0; i < message.double_values.length; ++i)
                                    writer.double(message.double_values[i]);
                                writer.ldelim();
                            }
                            if (message.bool_values != null && message.bool_values.length) {
                                writer.uint32(/* id 10, wireType 2 =*/82).fork();
                                for (var i = 0; i < message.bool_values.length; ++i)
                                    writer.bool(message.bool_values[i]);
                                writer.ldelim();
                            }
                            if (message.map_value != null && Object.hasOwnProperty.call(message, "map_value"))
                                $root.dynatrace.odin.proto.common.v1.AttributeKeyValue.MapValue.encode(message.map_value, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                            if (message.map_values != null && message.map_values.length)
                                for (var i = 0; i < message.map_values.length; ++i)
                                    $root.dynatrace.odin.proto.common.v1.AttributeKeyValue.MapValue.encode(message.map_values[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                            return writer;
                        };

                        /**
                         * Decodes an AttributeKeyValue message from the specified reader or buffer.
                         * @function decode
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {dynatrace.odin.proto.common.v1.AttributeKeyValue} AttributeKeyValue
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AttributeKeyValue.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.common.v1.AttributeKeyValue();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.key = reader.string();
                                        break;
                                    }
                                case 2: {
                                        message.type = reader.int32();
                                        break;
                                    }
                                case 3: {
                                        message.string_value = reader.string();
                                        break;
                                    }
                                case 4: {
                                        message.int_value = reader.int64();
                                        break;
                                    }
                                case 5: {
                                        message.double_value = reader.double();
                                        break;
                                    }
                                case 6: {
                                        message.bool_value = reader.bool();
                                        break;
                                    }
                                case 7: {
                                        if (!(message.string_values && message.string_values.length))
                                            message.string_values = [];
                                        message.string_values.push(reader.string());
                                        break;
                                    }
                                case 8: {
                                        if (!(message.int_values && message.int_values.length))
                                            message.int_values = [];
                                        if ((tag & 7) === 2) {
                                            var end2 = reader.uint32() + reader.pos;
                                            while (reader.pos < end2)
                                                message.int_values.push(reader.int64());
                                        } else
                                            message.int_values.push(reader.int64());
                                        break;
                                    }
                                case 9: {
                                        if (!(message.double_values && message.double_values.length))
                                            message.double_values = [];
                                        if ((tag & 7) === 2) {
                                            var end2 = reader.uint32() + reader.pos;
                                            while (reader.pos < end2)
                                                message.double_values.push(reader.double());
                                        } else
                                            message.double_values.push(reader.double());
                                        break;
                                    }
                                case 10: {
                                        if (!(message.bool_values && message.bool_values.length))
                                            message.bool_values = [];
                                        if ((tag & 7) === 2) {
                                            var end2 = reader.uint32() + reader.pos;
                                            while (reader.pos < end2)
                                                message.bool_values.push(reader.bool());
                                        } else
                                            message.bool_values.push(reader.bool());
                                        break;
                                    }
                                case 11: {
                                        message.map_value = $root.dynatrace.odin.proto.common.v1.AttributeKeyValue.MapValue.decode(reader, reader.uint32());
                                        break;
                                    }
                                case 12: {
                                        if (!(message.map_values && message.map_values.length))
                                            message.map_values = [];
                                        message.map_values.push($root.dynatrace.odin.proto.common.v1.AttributeKeyValue.MapValue.decode(reader, reader.uint32()));
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Gets the default type url for AttributeKeyValue
                         * @function getTypeUrl
                         * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        AttributeKeyValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/dynatrace.odin.proto.common.v1.AttributeKeyValue";
                        };

                        /**
                         * ValueType enum.
                         * @name dynatrace.odin.proto.common.v1.AttributeKeyValue.ValueType
                         * @enum {number}
                         * @property {number} STRING=0 STRING value
                         * @property {number} INT=1 INT value
                         * @property {number} DOUBLE=2 DOUBLE value
                         * @property {number} BOOL=3 BOOL value
                         * @property {number} MAP=5 MAP value
                         * @property {number} STRING_ARRAY=16 STRING_ARRAY value
                         * @property {number} INT_ARRAY=17 INT_ARRAY value
                         * @property {number} DOUBLE_ARRAY=18 DOUBLE_ARRAY value
                         * @property {number} BOOL_ARRAY=19 BOOL_ARRAY value
                         * @property {number} MAP_ARRAY=21 MAP_ARRAY value
                         * @property {number} VALUELESS_ARRAY=20 VALUELESS_ARRAY value
                         */
                        AttributeKeyValue.ValueType = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "STRING"] = 0;
                            values[valuesById[1] = "INT"] = 1;
                            values[valuesById[2] = "DOUBLE"] = 2;
                            values[valuesById[3] = "BOOL"] = 3;
                            values[valuesById[5] = "MAP"] = 5;
                            values[valuesById[16] = "STRING_ARRAY"] = 16;
                            values[valuesById[17] = "INT_ARRAY"] = 17;
                            values[valuesById[18] = "DOUBLE_ARRAY"] = 18;
                            values[valuesById[19] = "BOOL_ARRAY"] = 19;
                            values[valuesById[21] = "MAP_ARRAY"] = 21;
                            values[valuesById[20] = "VALUELESS_ARRAY"] = 20;
                            return values;
                        })();

                        AttributeKeyValue.MapValue = (function() {

                            /**
                             * Properties of a MapValue.
                             * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                             * @interface IMapValue
                             * @property {Array.<dynatrace.odin.proto.common.v1.IAttributeKeyValue>|null} [values] MapValue values
                             */

                            /**
                             * Constructs a new MapValue.
                             * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue
                             * @classdesc Represents a MapValue.
                             * @implements IMapValue
                             * @constructor
                             * @param {dynatrace.odin.proto.common.v1.AttributeKeyValue.IMapValue=} [properties] Properties to set
                             */
                            function MapValue(properties) {
                                this.values = [];
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }

                            /**
                             * MapValue values.
                             * @member {Array.<dynatrace.odin.proto.common.v1.IAttributeKeyValue>} values
                             * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue.MapValue
                             * @instance
                             */
                            MapValue.prototype.values = $util.emptyArray;

                            /**
                             * Encodes the specified MapValue message. Does not implicitly {@link dynatrace.odin.proto.common.v1.AttributeKeyValue.MapValue.verify|verify} messages.
                             * @function encode
                             * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue.MapValue
                             * @static
                             * @param {dynatrace.odin.proto.common.v1.AttributeKeyValue.IMapValue} message MapValue message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            MapValue.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.values != null && message.values.length)
                                    for (var i = 0; i < message.values.length; ++i)
                                        $root.dynatrace.odin.proto.common.v1.AttributeKeyValue.encode(message.values[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                                return writer;
                            };

                            /**
                             * Decodes a MapValue message from the specified reader or buffer.
                             * @function decode
                             * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue.MapValue
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {dynatrace.odin.proto.common.v1.AttributeKeyValue.MapValue} MapValue
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            MapValue.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.common.v1.AttributeKeyValue.MapValue();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1: {
                                            if (!(message.values && message.values.length))
                                                message.values = [];
                                            message.values.push($root.dynatrace.odin.proto.common.v1.AttributeKeyValue.decode(reader, reader.uint32()));
                                            break;
                                        }
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };

                            /**
                             * Gets the default type url for MapValue
                             * @function getTypeUrl
                             * @memberof dynatrace.odin.proto.common.v1.AttributeKeyValue.MapValue
                             * @static
                             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                             * @returns {string} The default type url
                             */
                            MapValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                                if (typeUrlPrefix === undefined) {
                                    typeUrlPrefix = "type.googleapis.com";
                                }
                                return typeUrlPrefix + "/dynatrace.odin.proto.common.v1.AttributeKeyValue.MapValue";
                            };

                            return MapValue;
                        })();

                        return AttributeKeyValue;
                    })();

                    v1.StringKeyValue = (function() {

                        /**
                         * Properties of a StringKeyValue.
                         * @memberof dynatrace.odin.proto.common.v1
                         * @interface IStringKeyValue
                         * @property {string|null} [key] StringKeyValue key
                         * @property {string|null} [value] StringKeyValue value
                         */

                        /**
                         * Constructs a new StringKeyValue.
                         * @memberof dynatrace.odin.proto.common.v1
                         * @classdesc Represents a StringKeyValue.
                         * @implements IStringKeyValue
                         * @constructor
                         * @param {dynatrace.odin.proto.common.v1.IStringKeyValue=} [properties] Properties to set
                         */
                        function StringKeyValue(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * StringKeyValue key.
                         * @member {string} key
                         * @memberof dynatrace.odin.proto.common.v1.StringKeyValue
                         * @instance
                         */
                        StringKeyValue.prototype.key = "";

                        /**
                         * StringKeyValue value.
                         * @member {string} value
                         * @memberof dynatrace.odin.proto.common.v1.StringKeyValue
                         * @instance
                         */
                        StringKeyValue.prototype.value = "";

                        /**
                         * Encodes the specified StringKeyValue message. Does not implicitly {@link dynatrace.odin.proto.common.v1.StringKeyValue.verify|verify} messages.
                         * @function encode
                         * @memberof dynatrace.odin.proto.common.v1.StringKeyValue
                         * @static
                         * @param {dynatrace.odin.proto.common.v1.IStringKeyValue} message StringKeyValue message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        StringKeyValue.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
                            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
                            return writer;
                        };

                        /**
                         * Decodes a StringKeyValue message from the specified reader or buffer.
                         * @function decode
                         * @memberof dynatrace.odin.proto.common.v1.StringKeyValue
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {dynatrace.odin.proto.common.v1.StringKeyValue} StringKeyValue
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        StringKeyValue.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.common.v1.StringKeyValue();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.key = reader.string();
                                        break;
                                    }
                                case 2: {
                                        message.value = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Gets the default type url for StringKeyValue
                         * @function getTypeUrl
                         * @memberof dynatrace.odin.proto.common.v1.StringKeyValue
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        StringKeyValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/dynatrace.odin.proto.common.v1.StringKeyValue";
                        };

                        return StringKeyValue;
                    })();

                    return v1;
                })();

                return common;
            })();

            proto.resource = (function() {

                /**
                 * Namespace resource.
                 * @memberof dynatrace.odin.proto
                 * @namespace
                 */
                var resource = {};

                resource.v1 = (function() {

                    /**
                     * Namespace v1.
                     * @memberof dynatrace.odin.proto.resource
                     * @namespace
                     */
                    var v1 = {};

                    v1.Resource = (function() {

                        /**
                         * Properties of a Resource.
                         * @memberof dynatrace.odin.proto.resource.v1
                         * @interface IResource
                         * @property {Array.<dynatrace.odin.proto.common.v1.IAttributeKeyValue>|null} [attributes] Resource attributes
                         * @property {number|null} [dropped_attributes_count] Resource dropped_attributes_count
                         */

                        /**
                         * Constructs a new Resource.
                         * @memberof dynatrace.odin.proto.resource.v1
                         * @classdesc Represents a Resource.
                         * @implements IResource
                         * @constructor
                         * @param {dynatrace.odin.proto.resource.v1.IResource=} [properties] Properties to set
                         */
                        function Resource(properties) {
                            this.attributes = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Resource attributes.
                         * @member {Array.<dynatrace.odin.proto.common.v1.IAttributeKeyValue>} attributes
                         * @memberof dynatrace.odin.proto.resource.v1.Resource
                         * @instance
                         */
                        Resource.prototype.attributes = $util.emptyArray;

                        /**
                         * Resource dropped_attributes_count.
                         * @member {number} dropped_attributes_count
                         * @memberof dynatrace.odin.proto.resource.v1.Resource
                         * @instance
                         */
                        Resource.prototype.dropped_attributes_count = 0;

                        /**
                         * Encodes the specified Resource message. Does not implicitly {@link dynatrace.odin.proto.resource.v1.Resource.verify|verify} messages.
                         * @function encode
                         * @memberof dynatrace.odin.proto.resource.v1.Resource
                         * @static
                         * @param {dynatrace.odin.proto.resource.v1.IResource} message Resource message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Resource.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.attributes != null && message.attributes.length)
                                for (var i = 0; i < message.attributes.length; ++i)
                                    $root.dynatrace.odin.proto.common.v1.AttributeKeyValue.encode(message.attributes[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.dropped_attributes_count != null && Object.hasOwnProperty.call(message, "dropped_attributes_count"))
                                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.dropped_attributes_count);
                            return writer;
                        };

                        /**
                         * Decodes a Resource message from the specified reader or buffer.
                         * @function decode
                         * @memberof dynatrace.odin.proto.resource.v1.Resource
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {dynatrace.odin.proto.resource.v1.Resource} Resource
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Resource.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.dynatrace.odin.proto.resource.v1.Resource();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        if (!(message.attributes && message.attributes.length))
                                            message.attributes = [];
                                        message.attributes.push($root.dynatrace.odin.proto.common.v1.AttributeKeyValue.decode(reader, reader.uint32()));
                                        break;
                                    }
                                case 2: {
                                        message.dropped_attributes_count = reader.uint32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Gets the default type url for Resource
                         * @function getTypeUrl
                         * @memberof dynatrace.odin.proto.resource.v1.Resource
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Resource.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/dynatrace.odin.proto.resource.v1.Resource";
                        };

                        return Resource;
                    })();

                    return v1;
                })();

                return resource;
            })();

            return proto;
        })();

        return odin;
    })();

    return dynatrace;
})();

module.exports = $root;
